export default "__VITE_ASSET__C6$5ZhOZ__"